import React from "react";
import { View, Text, ScrollView } from "react-native";
import { AppBar } from "@/elements/components/ui/app-bar";
import ResponsiveContent from "@/elements/components/shared/responsive-content";
import goBack from "../utils/go-back";

function StudentLessonRecording() {
  return (
    <View className="flex-1 bg-teachLoop-accentPrimary">
      <AppBar>
        <AppBar.Icon pathClassName="stroke-white" onPress={goBack} />
        <AppBar.Title className="text-white">Back</AppBar.Title>
      </AppBar>

      <ScrollView showsVerticalScrollIndicator={false}>
        <ResponsiveContent>
          <View className="mx-5 gap-2">
            <Text className="font-zilla-slab-medium text-[28px] text-teachLoop-creamLight">
              Live lesson in progress...
            </Text>
            <Text className="font-geologica-regular text-xl text-teachLoop-creamLight">
              This session is being recorded
            </Text>
          </View>
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default StudentLessonRecording;
